'use strict';

import focusables from './focusables';

const _ = new WeakMap();

export default function FocusJail(areas = []) {

    const o = {
        areas: areas,
        map: null,
        observers: [],
        handler: function (e) {
            if (e.keyCode !== 9) {
                return;
            }
            if (this !== document.activeElement) {
                return;
            }
            if (!o.map) {
                return;
            }
            const target = o.map.get(this);
            if (!target) {
                return;
            }
            if (e.shiftKey) {
                // jump to previous if any
                if (target.previous) {
                    e.preventDefault();
                    target.previous.focus();
                }
            } else {
                // jump to next if any
                if (target.next) {
                    e.preventDefault();
                    target.next.focus();
                }
            }
        },
        removeListeners: () => {
            o.map && o.map.forEach(function (value, key) {
                key && key.removeEventListener('keydown', o.handler);
            });
        }
    };

    _.set(this, o);
}

FocusJail.prototype.jail = function () {
    const o = _.get(this);
    this.update();
    o.observers = Array.prototype.map.call(o.areas, (area) => {
        const observer = new MutationObserver(() => this.update());
        observer.observe(area, {
            subtree: true,
            childList: true
        });
        return observer;
    });
};

FocusJail.prototype.free = function () {
    const o = _.get(this);
    o.observers && o.observers.forEach(observer => observer.disconnect());
    o.observers = null;
    o.removeListeners();
};

FocusJail.prototype.contains = function (element) {
    const o = _.get(this);
    for (const area of o.areas) {
        if (area.contains(element)) {
            return true;
        }
    }
    return false;
}

FocusJail.prototype.destroy = function () {
    this.free();
    return _.delete(this);
};

FocusJail.prototype.update = function () {
    const o = _.get(this);
    o.removeListeners();
    o.map = new Map();

    let first, last;

    // build map with previous and next focusable elements
    Array.prototype.forEach.call(o.areas, (area) => {

        const areaFocusables = focusables(area);

        if (!areaFocusables.length) {
            return;
        }

        const areaFirst = areaFocusables[0];
        const areaLast = areaFocusables[areaFocusables.length - 1];

        o.map.set(areaFirst, {});
        o.map.set(areaLast, {});

        if (last) {
            o.map.get(last).next = areaFirst;
            o.map.get(areaFirst).previous = last;
        }

        last = areaLast;

        if (!first) {
            first = areaFirst;
        }

        if (areaFocusables.length > 1) {
            // in case focus is programmatically put on an area itself
            o.map.set(area, o.map.get(areaFirst));
        }
    });

    // connect first and last
    if (first && last) {
        o.map.get(first).previous = last;
        o.map.get(last).next = first;
    }

    // set listeners
    o.map.forEach((value, key) => {
        key && key.addEventListener('keydown', o.handler);
    });
};